import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from './ui/button';
import { Popover, PopoverTrigger, PopoverContent } from './ui/popover';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// The secondary worklist facets (provider / department / payer / visit type)
// collapsed behind one counted button so they stop occluding the queue. The
// timeframe and state segments stay inline in the toolbar; these four — used
// less often — live here. A count badge keeps "I have filters applied" visible,
// and the ActiveFilterBreadcrumb above the queue shows exactly which.
export default function FiltersPopover({
  provider, setProvider, location, setLocation, payer, setPayer, visitType, setVisitType,
  providers = [], locations = [], payers = [], visitTypes = [], clearFilters,
}) {
  const count = [provider, location, payer, visitType].filter((v) => v !== 'all').length;
  const trig = 'h-9 w-full bg-white text-sm';

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-9">
          <SlidersHorizontal className="h-4 w-4 mr-1.5" />
          Filters
          {count > 0 && <span className="ml-1.5 tnum text-[11px] font-semibold bg-brand-100 text-brand-700 rounded-full px-1.5 min-w-[18px] text-center">{count}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-3 space-y-3">
        <div className="flex items-center justify-between">
          <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">Filter appointments</div>
          {count > 0 && <button onClick={clearFilters} className="text-xs text-slate-500 hover:text-slate-800">Clear</button>}
        </div>
        <div className="space-y-2.5">
          <div>
            <div className="text-xs text-slate-500 mb-1">Provider</div>
            <Select value={provider} onValueChange={setProvider}>
              <SelectTrigger className={trig}><SelectValue placeholder="Provider" /></SelectTrigger>
              <SelectContent><SelectItem value="all">All providers</SelectItem>{providers.map((p) => <SelectItem key={p.id} value={p.id}>Dr. {p.lastName}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <div className="text-xs text-slate-500 mb-1">Department</div>
            <Select value={location} onValueChange={setLocation}>
              <SelectTrigger className={trig}><SelectValue placeholder="Department" /></SelectTrigger>
              <SelectContent><SelectItem value="all">All departments</SelectItem>{locations.map((l) => <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <div className="text-xs text-slate-500 mb-1">Payer</div>
            <Select value={payer} onValueChange={setPayer}>
              <SelectTrigger className={trig}><SelectValue placeholder="Payer" /></SelectTrigger>
              <SelectContent><SelectItem value="all">All payers</SelectItem>{payers.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <div className="text-xs text-slate-500 mb-1">Visit type</div>
            <Select value={visitType} onValueChange={setVisitType}>
              <SelectTrigger className={trig}><SelectValue placeholder="Visit type" /></SelectTrigger>
              <SelectContent><SelectItem value="all">All visit types</SelectItem>{visitTypes.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
